import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

type ParamValue = string | number | boolean | null | undefined;

export const useQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getParam = useCallback(
    <T = string>(key: string, defaultValue?: T): T => {
      const value = searchParams.get(key);

      if (value === null) {
        return defaultValue as T;
      }

      return value as unknown as T;
    },
    [searchParams],
  );

  const updateParams = useCallback(
    (newParams: Record<string, ParamValue>) => {
      setSearchParams((prev) => {
        const currentParams = Object.fromEntries(prev.entries());

        Object.entries(newParams).forEach(([key, value]) => {
          if (value === undefined || value === null || value === "") {
            delete currentParams[key];
          } else {
            currentParams[key] = String(value);
          }
        });

        return currentParams;
      });
    },
    [setSearchParams],
  );

  const clearParams = useCallback(() => {
    setSearchParams({});
  }, [setSearchParams]);

  return {
    searchParams,
    getParam,
    updateParams,
    clearParams,
  };
};
